// @ts-nocheck
import React from "react";
import { t } from "i18next";
import ScrollTable from "components/ScrollTable/ScrollTable";
import moment from "moment";

export default function AnimationsDraftsTable({events, onItemClick}) {
	return (
		<ScrollTable
			cols={[
				{
					title: t("Table.TITLE"),
					name: "title",
					classes: "post-title-cell"
				},
				{
					title: t("Events.START_DATE"),
					name: "dateStart",
					classes: "post-date-cell",
					component: DateCell,
					childProps: {
						itemKey: "dateStart"
					}
				},
				{
					title: t("Events.END_DATE"),
					name: "dateEnd",
					classes: "post-date-cell",
					component: DateCell,
					childProps: {
						itemKey: "dateEnd"
					}
				},
				{
					title: t("Commons.LAST_CHANGED"),
					name: "lastChanged",
					classes: "post-date-cell",
					component: DateCell,
					childProps: {
						itemKey: "lastChanged"
					}
				}
			]}
			sortBy="lastChanged"
			revSort={true}
			itemId={"animationId"}
			items={events}
			onItemClick={onItemClick}
		/>
	);
}

function DateCell(props) {
	const {item} = props;

	if (!props.itemKey || !item[props.itemKey])
		return (false);
	return (
		<div className="d-flex align-items-center">
			{moment(item[props.itemKey]).format(t("Events.DATE_TIME_FORMAT"))}
		</div>
	);
}
